module.exports = "<button class=\"btn btn-default pr-15\" [disabled]=\"isDisabled\">\n    <i class=\"fa fa-cog pl-5\"></i>\n    <span>{{ text }}</span>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/settings-btn/settings-btn.html
// module id = ./web/modern/components/buttons/settings-btn/settings-btn.html
// module chunks = 0